import React, { useEffect, useState } from "react";
import { Table, Tag, Card, Input, Row, Col } from "antd";
import { UserService } from "../../Services/Manage/UserService";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

function SalarySlip() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();

  const getAllServices = async () => {
    try {
      const request = await UserService.getAllUsers();
      const formattedData = request.data.map((item, index) => ({
        ...item,
        si_no: index + 1,
        key: item.id,
      }));
      setData(formattedData);
      setFilteredData(formattedData);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllServices();
  }, []);


  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    const filtered = data.filter(
      (item) =>
        String(item.user_id)?.toLowerCase().includes(value) ||

        item.name?.toLowerCase().includes(value) ||
        item.role?.toLowerCase().includes(value) ||
        item.department_name?.toLowerCase().includes(value) ||
        item.email?.toLowerCase().includes(value) ||
        item.phone?.toLowerCase().includes(value) ||
        item.status?.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  const columns = [
    { title: "S. No", dataIndex: "si_no", key: "si_no", align: "center" },
    { title: "UID", dataIndex: "user_id", key: "user_id" },
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Role", dataIndex: "role", key: "role" },
    { title: "Department", dataIndex: "department_name", key: "department_name" },
    { title: "Email", dataIndex: "email", key: "email" },
    { title: "Phone", dataIndex: "phone", key: "phone" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "Active" ? "green" : "red"}>{status}</Tag>
      ),
    },
    {
      title: "Added On",
      dataIndex: "eq_date",
      key: "eq_date",
      render: (value) => dayjs(value).format("DD-MM-YYYY hh:mm A"),
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <button
          style={{
            padding: "6px 12px",
            backgroundColor: "#1890ff",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
          onClick={() =>
            navigate("/workforce-management/actions", {
              state: {
                userId: record.id,
                user_id: record.user_id,
                addedBy: record.added_by,
                departmentId: record.department_id,
                name: record.name,
                department: record.department_name,
                phone: record.phone,
                status: record.status,
              },
            })
          }
        >
          View
        </button>
      ),
    },
  ];

  return (
    <Card
      title={
        <Row justify="space-between" align="middle">
          <Col>
            <h3 style={{ margin: 0 }}>User List</h3>
          </Col>
          <Col>
            <Input
              placeholder="Search..."
              value={searchText}
              onChange={handleSearch}
              allowClear
                size="large"
              style={{ width: 250 }}
            />
          </Col>
        </Row>
      }
     
    >
      <Table
        columns={columns}
        dataSource={filteredData}
        pagination={true}
        scroll={{ x: "max-content" }}
      />
    </Card>
  );
}

export default SalarySlip;
